import React from 'react';
import { MapPin, Phone, Clock, ArrowRight } from 'lucide-react';
import Logo from './Logo';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#EFE8DD] pt-16 pb-10">
      <div className="vertical-divider hidden lg:block"></div>

      <div className="max-w-[1400px] mx-auto px-8 lg:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 pb-10">
          {/* Brand */}
          <div>
            <Logo size={56} />
            <p className="mt-6 text-[13px] text-[#1E1B18]/60 leading-relaxed max-w-xs">
              Registered Massage Therapy — Swedish massage, lymphatic drainage, and prenatal care in a calm, welcoming space.
            </p>
          </div>

          {/* Visit */}
          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#1E1B18]/50 font-medium mb-5">VISIT</p>
            <div className="space-y-4 text-[13px] text-[#1E1B18]/80">
              <div className="flex items-start gap-3">
                <MapPin size={15} className="mt-0.5 text-[#1E1B18]/50 shrink-0" strokeWidth={1.5} />
                <div>
                  <div>{businessInfo.address.line1}</div>
                  <div>{businessInfo.address.line2}</div>
                  <div>{businessInfo.address.line3}</div>
                  <div className="text-[#1E1B18]/50 mt-1">{businessInfo.locationNote}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={15} className="text-[#1E1B18]/50 shrink-0" strokeWidth={1.5} />
                <span>{businessInfo.phone}</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#1E1B18]/50 font-medium mb-5">HOURS</p>
            <div className="space-y-2 text-[13px] text-[#1E1B18]/80">
              {businessInfo.hours.map((h) => (
                <div key={h.day} className="flex items-center gap-3">
                  <Clock size={15} className="text-[#1E1B18]/50 shrink-0" strokeWidth={1.5} />
                  <span>{h.day} · {h.time}</span>
                </div>
              ))}
            </div>
            <button
              onClick={scrollToBooking}
              className="mt-6 inline-flex items-center gap-2 text-[13px] text-[#8B7FB8] hover:text-[#7B6BA6] font-medium transition-colors group"
            >
              Book an appointment
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        <div className="border-t border-[#1E1B18]/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6 text-[12px] text-[#1E1B18]/50">
            <a href="#privacy" className="hover:text-[#1E1B18] transition-colors">Privacy</a>
            <a href="#terms" className="hover:text-[#1E1B18] transition-colors">Terms</a>
            <a href="#accessibility" className="hover:text-[#1E1B18] transition-colors">Accessibility</a>
            <a href="/gift-cards" data-testid="footer-gift-cards-link" className="hover:text-[#1E1B18] transition-colors">Gift Cards</a>
          </div>
          <p className="text-[12px] text-[#1E1B18]/40">
            © {new Date().getFullYear()} Aura Lune. All rights reserved.
            <a href="/mississauga-rmt" data-testid="footer-seo-link" className="ml-2 text-[10px] text-[#1E1B18]/25 hover:text-[#1E1B18]/50 transition-colors">RMT Mississauga</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
